<template>
  <div class="poster" v-if="isLoad">
    <div class="title">恭喜你！打卡上传成功</div>

    <div class="image">
      <img :src="imgPath" width="300px">
    </div>

    <record-poster v-if="!posterUrl" :poster-data="posterData" @success="success" @fail="fail" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'
import RecordPoster from '@/components/Poster/RecordPoster'
import { getRecordPoster, setRecordPoster, getRecordPosterData } from '@/api/record'
import { uploadImageToOss } from '@/api/upload'
import { getUploadParams, base64ToFile } from '@/utils/upload'

export default {
  name: 'dakaposter',
  components: {
    RecordPoster
  },
  data () {
    return {
      isLoad: false,
      recordId: null,
      imgPath: '',
      posterUrl: null,
      posterData: null
      // posterData: {
      //   bg_img: '',
      //   is_vertical: true,
      //   chicken_soup: '',
      //   days: 200,
      //   day_distance: 111,
      //   day_minutes: 100,
      //   total_distance: 8899
      // }
    }
  },
  computed: {
    ...mapGetters([
      'ossToken'
    ])
  },
  created () {
    this.recordId = this.$route.query.record_id
    if (this.recordId) {
      this.getPoster()
    }
  },
  methods: {
    async getPoster () {
      const res = await getRecordPoster({ record_id: this.recordId })
      this.posterUrl = res.data.poster_url
      if (!this.posterUrl) {
        this.getPosterData()
      } else {
        this.imgPath = this.posterUrl
        this.isLoad = true
      }
    },
    async getPosterData () {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      const res = await getRecordPosterData({
        record_id: this.recordId
      })
      this.posterData = res.data
      this.isLoad = true
    },
    success (src) {
      Toast.clear()
      this.imgPath = src
      if (!this.posterUrl) {
        const file = base64ToFile(src, 'poster.png')
        this.upload(file)
      }
    },
    fail (err) {
      Toast.clear()
      console.log('fail', err)
    },
    async upload (fileObj) {
      await this.$store.dispatch('GetOssToken', 'record_poster')
      const formData = getUploadParams(this.ossToken, fileObj)

      await uploadImageToOss(this.ossToken.host, formData)
      const filePath = formData.get('key')
      await setRecordPoster({
        record_id: this.recordId,
        poster: filePath
      })
    }
  }
}
</script>

<style lang="scss">
.poster {
  .title {
    padding: 60px 0 20px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
  }
  .image {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
